
import { Vue, Options, prop } from "vue-class-component";
import { ConfigSidebar } from "@/domain/entities/MainApp";
import { MainAppController } from "../../controllers/MainAppController";

class Props {
  data = prop<ConfigSidebar>({
    type: Object,
    default: null
  });
  active = prop<boolean>({ type: Boolean, default: false });
  open = prop<boolean>({ type: Boolean, default: false });
  isCollapsed = prop<boolean>({ type: Boolean, default: false });
  tree = prop<boolean>({ type: Boolean, default: false });
  last = prop<boolean>({ type: Boolean, default: false });
  index = prop<number>({ type: Number, default: -1 });
}

@Options({
  emits: ["click"]
})
export default class SidebarItem extends Vue.with(Props) {
  // --- State ---
  showPopover = false;
  trigger: HTMLElement | null = null;
  popoverPos = { top: 0, left: 0 };
  maxHeight = 0;
  sidebarScrollContainer: HTMLElement | null = null;

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    // Cari elemen sidebar yang bisa di-scroll
    this.sidebarScrollContainer = document.querySelector(
      ".sidebar-scroll"
    ) as HTMLElement;
    if (this.sidebarScrollContainer) {
      this.sidebarScrollContainer.addEventListener(
        "scroll",
        this.repositionPopover,
        {
          passive: true
        }
      );
    }
  }

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this.sidebarScrollContainer) {
      this.sidebarScrollContainer.removeEventListener(
        "scroll",
        this.repositionPopover
      );
    }
  }

  // --- Methods ---
  onToggle(event: MouseEvent) {
    this.trigger = event.currentTarget as HTMLElement;
    this.updatePopoverPosition();
    this.showPopover = !this.showPopover;
  }

  updatePopoverPosition() {
    if (!this.trigger) return;

    const rect = this.trigger.getBoundingClientRect();
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    const viewportHeight = window.innerHeight;
    const margin = 8;
    const minHeight = 150;

    let top = rect.bottom + scrollY;
    let maxHeight = viewportHeight - rect.bottom - margin;

    if (maxHeight < minHeight) {
      const spaceAbove = rect.top - margin;
      if (spaceAbove > minHeight) {
        top = scrollY + rect.top - 40;
        maxHeight = Math.min(175, spaceAbove);
      } else {
        if (spaceAbove > maxHeight) {
          top = scrollY + rect.top - spaceAbove + 30;
          maxHeight = spaceAbove;
        }
      }
    }

    this.popoverPos = {
      top: top - (maxHeight < minHeight ? 0 : 100),
      left: rect.right + scrollX + 4
    };
    this.maxHeight = maxHeight;
  }

  repositionPopover = () => {
    if (this.showPopover) {
      this.updatePopoverPosition();
    }
  };

  handleClickOutside(e: MouseEvent) {
    if (
      this.trigger &&
      !this.trigger.contains(e.target as Node) &&
      !document
        .getElementById("sidebar-v2-sub-menu")
        ?.contains(e.target as Node)
    ) {
      this.showPopover = false;
    }
  }

  onClick(event: MouseEvent) {
    if (this.isCollapsed && this.data.children?.length) {
      this.onToggle(event);
    } else {
      this.$emit("click", this.data);
    }
  }

  get showIconNotificationMenuSidebar() {
    return MainAppController.showIconNotificationMenuSidebar;
  }

  get iconSrc(): string | null {
    if (!this.data?.icon) return null;
    try {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const src = require(`@/app/ui/layout/sidebar/icons/${this.data.icon}.svg`);
      return src?.default ?? src ?? null;
    } catch {
      return null;
    }
  }
}
